import React from 'react';
import styles from './styles.css';
import {observer} from 'mobx-react';

function NotAuthorised() {
  return (
    <div className={styles.notAuthorised}>
      <h1>ACCESS DENIED</h1>
      <i className="material-icons">not_interested</i>
    </div>
  );
}

export default observer(NotAuthorised);



// WEBPACK FOOTER //
// ./src/views/NotAuthorised/NotAuthorised.js